import * as React from "react";
import type { SVGProps } from "react";
const SvgPause = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 4V3a1 1 0 0 0-1 1zm4 0h1a1 1 0 0 0-1-1zm0 16v1a1 1 0 0 0 1-1zm-4 0H5a1 1 0 0 0 1 1zm8-16V3a1 1 0 0 0-1 1zm4 0h1a1 1 0 0 0-1-1zm0 16v1a1 1 0 0 0 1-1zm-4 0h-1a1 1 0 0 0 1 1zM6 5h4V3H6zm3-1v16h2V4zm1 15H6v2h4zm-3 1V4H5v16zm7-15h4V3h-4zm3-1v16h2V4zm1 15h-4v2h4zm-3 1V4h-2v16z"
    />
  </svg>
);
export default SvgPause;
